import { defineMessages } from "@/i18n";
import en from "./en";

export const pagesCanvasMessages = defineMessages("pages-canvas", en);
